import React, { Component } from "react";
import {
  Box,
  Paper,
  Container,
  Typography,
  Switch,
  Divider,
  Tab,
  Tabs,
  Button,
  Grid,
  Card,
  Autocomplete,
  Pagination,
  Stack,
  Modal
} from "@mui/material";
import Slider from "@mui/material/Slider";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import three from './img/three.jpg'
import Checkbox from '@mui/material/Checkbox';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import Chip from '@mui/material/Chip';
import {TextField} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Autocompletee from "react-google-autocomplete";
import base from '../src/base.json'
import AppHeader from "./AppHeader";
import Footer from "./Footer";


///AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0
const api_key = "AIzaSyDg2LA8IAl3SPgxqiAt1FBNb54Z8jk4kZ0"

const MAX = 100;
const MIN = 0;
const marks = [
  {
    value: MIN,
    label: "",
  },
  {
    value: MAX,
    label: "",
  },
];

export class Properties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slider_value: 70,
      tab_value: "1",


      multi_seach_data : ["1 RESIDENTIAL PLOT","1 RESIDENTIAL LAND","1 BHK"],




     propertyList : [],
     type_of_property :"",
     no_of_bedrooms:"",
     construction_status :"",


     location : "",


     page : 0,
     size:0,



     /////////////////////////////////////
name :"",
email:"",
phone:"",
propertyDetails :{},
 is_enquiry_open :false,

    };
    this.handlePageChange = this.handlePageChange.bind(this)
  }




componentDidMount(){
   fetch(
      `${base.base_url}/property_portal/property_portal/property/retriveAllPropertyList/:${this.state.page}/:${this.state.type_of_property}/:${this.state.construction_status}/:${this.state.no_of_bedrooms}/:${this.state.location}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          propertyList: result.data,
          size: result.size,
          is_loader_open: false,
        });
      });
}




instantRetrive=()=>{
   fetch(
          `${base.base_url}/property_portal/property_portal/property/retriveAllPropertyList/:${this.state.page}/:${this.state.type_of_property}/:${this.state.construction_status}/:${this.state.no_of_bedrooms}/:${this.state.location}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          propertyList: result.data,
          size: result.size,
          is_loader_open: false,
        });
      });
}


   formatIndianCurrency=(num)=>{
  if (num >= 10000000) {
    return (num / 10000000).toFixed(2) + ' Cr';
  } else if (num >= 100000) {
    return (num / 100000).toFixed(2) + ' Lakh';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(2) + ' K';
  } else {
    return num.toString();
  }
}


 handlePageChange = (event, pageNumber) => {
  alert(pageNumber)
    this.setState({
      page : pageNumber
    },()=>{
       this.instantRetrive();
    })
  
 }



 saveLeads=()=>{
   
   if(
     this.state.name != "",
 this.state.email!= "",
 this.state.phone!= ""
   ){
     fetch(`${base.base_url}/property_portal/property_portal/property/addNewLeads`, {
       headers:{
         'authorization': `Bearer ${sessionStorage.getItem('token')}`,
     'content-type':'application/json',
    // 'Access-Control-Allow-Origin': 'http://localhost:3000',
       },
           method: "post",
           body:JSON.stringify({
                       email : this.state.email,
                       phone:this.state.phone,
                       name :this.state.name,
                       propertyDetails:this.state.propertyDetails
             })
   
         }).then(function(response) {
           return response.json();
         })
         .then(async(data)=> {
           this.setState({
             name:'',
             email:"",
             phone:"",
             is_enquiry_open:false
           })
          alert("Enquiry done")
         });
   }else{
     alert("fill all fields")
   }
 }
 



  render() {
    return (
      <div>
 <AppHeader/>
        <Box sx={{ backgroundColor: "#f8f9fa", minHeight: 900, width: "100%" }}>
          <Container maxWidth="xxl">
            <br />
            <br />
            <br />

            <Box
              sx={{ ml: { xs: 0, sm: 0, md: 3 }, mr: { xs: 0, sm: 0, md: 3 } }}
            >
              <Grid container spacing={2}>
                <Grid sx={{display:{xs:"none",sm:'none',md:'block'}}} size={{xs:12,sm:12,md:3}} item>
                  <Card
                    sx={{
                      width: "100%",
                      minHeight: 600,
                      backgroundColor: "#fff",
                     border: 1,
                      borderColor: "#ebebf5",
                      borderRadius: 1,
                    }}
                  >
                    <Box sx={{ padding: 3 }}>

                 

                         <Button size="small" variant="contained" color="warning" sx={{fontSize:10,fontWeight:'bold'}} onClick={()=>{
                          this.setState({
                            type_of_property :"",
     no_of_bedrooms:"",
     construction_status :"",
     location:""
                          },()=>{
                            this.instantRetrive();
                          })
                         }}>Filter Clear</Button>
                      <br/>
                      <br />
                      <Typography
                        sx={{
                          fontSize: 16,
                          color: "black",
                          fontWeight: "600",
                          
                        }}
                      >
                        Budget
                      </Typography>
                      <br />
                      <br />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: -1.5,
                        }}
                      >
                        <Box
                          sx={{
                            height: 20,
                            width: 30,
                            backgroundColor: "#00c6c6",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: "800",
                              textAlign: "center",
                              color: "#fff",
                            }}
                          >
                            0 L
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            height: 20,
                            width: 40,
                            backgroundColor: "#00c6c6",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 13,
                              fontWeight: "800",
                              textAlign: "center",
                              color: "#fff",
                            }}
                          >
                            10 Cr
                          </Typography>
                        </Box>
                      </Box>

                      <Slider
                        size="small"
                        defaultValue={this.state.slider_value}
                        aria-label="Small"
                        valueLabelDisplay="auto"
                        min={0}
                        max={1000}
                        color="primary"
                        onChange={(e) => {
                          this.setState({
                            slider_value: e.target.value,
                          });
                        }}
                        valueLabelFormat={`${this.state.slider_value} LAKH`}
                      />


<Divider/>

<Box sx={{mt:2,mb:2}}>
<Typography sx={{fontSize:17,fontWeight:'600',color:'black',mb:2}}>Type Of Property</Typography>

<Button variant={this.state.type_of_property=="FLATS"? "contained" :"outlined"} onClick={()=>this.setState({type_of_property:'FLATS'},()=>this.instantRetrive())} size="small" sx={{height:27,fontSize:11,borderRadius:3}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>RESIDENTIAL FLATS</Button>
<Button variant={this.state.type_of_property=="LAND"? "contained" :"outlined"} onClick={()=>this.setState({type_of_property:'LAND'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>RESIDENTIAL LAND</Button>
<Button variant={this.state.type_of_property=="INDEPENDENT HOUSE"? "contained" :"outlined"} onClick={()=>this.setState({type_of_property:'INDEPENDENT HOUSE'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>INDEPENDENT HOUSE/VILLA</Button>
<Button variant={this.state.type_of_property=="COMMERCIAL"? "contained" :"outlined"} onClick={()=>this.setState({type_of_property:'COMMERCIAL'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>COMMERCIAL</Button>


</Box>




<Divider/>

<Box sx={{mt:2,mb:2}}>
<Typography sx={{fontSize:17,fontWeight:'600',color:'black',mb:2}}>No. of Bedrooms</Typography>
<Button variant={this.state.no_of_bedrooms=="1 RK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'1 RK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>1 RK</Button>
<Button variant={this.state.no_of_bedrooms=="1 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'1 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>1 BHK</Button>
<Button variant={this.state.no_of_bedrooms=="2 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'2 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>2 BHK</Button>
<Button variant={this.state.no_of_bedrooms=="3 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'3 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>3 BHK</Button>
<Button variant={this.state.no_of_bedrooms=="4 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'4 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>4 BHK</Button>
<Button variant={this.state.no_of_bedrooms=="5 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'5 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>5 BHK</Button>
<Button variant={this.state.no_of_bedrooms=="6 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'6 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>6 BHK  </Button>
<Button variant={this.state.no_of_bedrooms=="7 BHK"? "contained" :"outlined"} onClick={()=>this.setState({no_of_bedrooms:'7 BHK'},()=>this.instantRetrive())}  size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>7 BHK</Button>
</Box>





<Divider/>

<Box sx={{mt:2,mb:2}}>
<Typography sx={{fontSize:17,fontWeight:'600',color:'black',mb:2}}>Construction Status</Typography>

<Button variant={this.state.construction_status=="NEW LAUNCH"? "contained" :"outlined"} onClick={()=>this.setState({construction_status:'NEW LAUNCH'},()=>this.instantRetrive())} size="small" sx={{height:27,fontSize:11,borderRadius:3,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>1 NEW LAUNCH</Button>
<Button variant={this.state.construction_status=="UNDER CONSTRUCTION"? "contained" :"outlined"} onClick={()=>this.setState({construction_status:'UNDER CONSTRUCTION'},()=>this.instantRetrive())} size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>2 UNDER CONSTRUCTION</Button>
<Button variant={this.state.construction_status=="READY TO MOVE"? "contained" :"outlined"} onClick={()=>this.setState({construction_status:'READY TO MOVE'},()=>this.instantRetrive())} size="small" sx={{height:27,fontSize:11,borderRadius:3,mt:1,mr:1}} startIcon={<AddIcon sx={{mr:-0.5,height:13,width:13}}/>}>3 READY TO MOVE</Button>


</Box>
















                    </Box>
                  </Card>
                </Grid>

                {
                  ///// property  list and short list data
                }

                <Grid item  size={{xs:12,sm:12,md:9}} >
                  <Box>

                   

                    <Paper elevation={1} sx={{height:50,width:'100%',mt:1,mb:1,display:'flex',justifyContent:'space-between'}}>
  <Box sx={{height:50,width:'100%',display:'flex',}}>
<SearchIcon sx={{mt:1.8,color:'#a4a4a4',ml:1}}/> 
{
  ///  this.setState({ location:place? place.formatted_address : ""})
}
<Autocompletee
  apiKey={api_key}
  onPlaceSelected={(place) => this.setState({ location:place?place.address_components[0].long_name : ""})}
  style={{borderRadius:5,border:'none',borderColor:'white',outline:'none',width:'100%'}}
/>
  </Box>

  <Box sx={{height:50,width:'100%',display:'flex',justifyContent:'right',alignItems:'center'}}>
  <Button onClick={this.instantRetrive} size="small" variant="contained" sx={{height:30,mr:1}} disableElevation endIcon={<SearchIcon />}>
  Search
  </Button>
</Box>
                    </Paper>




{
  ////// desktop view property list
}



{
this.state.propertyList.map((row)=>(
  <Box sx={{width:'100%'}} onClick={()=>window.open(`/Properties/:${row._id}`)}>
    <Card
                      sx={{
                        //width: "100%",
                        minHeight: 240,
                        backgroundColor: "#fff",
                        borderRadius: 1,
                        border:1, 
                        borderColor: "#eff0f0",
                        mt:2,
                       // display:'flex',
                      }}
                    >

<Grid container spacing={1}>
<Grid item  size={{xs:12,sm:12,md:4}} >
   <Box sx={{backgroundImage:`url(${base.base_url+'/'+ row.property_thumbnail_img})`,height:300, width:'100%' ,backgroundRepeat: 'no-repeat',backgroundPosition:'center',backgroundSize:'cover',borderRadius:2}}>
                         <Typography sx={{fontSize:10}}>.</Typography>
                         <Box sx={{height:35,width:35,backgroundColor:'rgb(255,255,255,0.8)',borderRadius:9,ml:1}}>
                           <Checkbox size="small"  icon={<FavoriteBorder />} checkedIcon={<Favorite />} />
                         </Box>
                     
{
  //// at image button and another statics data will display
}

<Box sx={{display:'flex',flexDirection:'column',justifyContent:'flex-end',height:'80%'}}>
<Typography sx={{fontSize:11,fontWeight:'500',color:'#fff',display:'flex',ml:2}}>1 VIDEOS | {row.property_imagelist?.length} IMAGES</Typography>
</Box>

                      </Box>
                      
</Grid>

<Grid item size={{xs:12,sm:12,md:8}} >
  <Box sx={{backgroundColor:'#fff'}}>
    <br/>
<Typography sx={{fontSize:16,fontWeight:'700',pl:2,color:'#010c1f',pr:2 ,textTransform:'capitalize'}}>{row.property_name==""?row.property_category:row.property_name}</Typography>
<Typography sx={{fontSize:11,fontWeight:'400',pl:2,color:'#a0a0a0',pr:2}}>{row.property_city_name}, {row.property_district} - {row.property_state}<Button size="small" disableElevation sx={{height:17,fontSize:10,ml:0.5}} variant="contained" endIcon={<DoneAllIcon sx={{height:13,width:13,color:'#ab266c'}}/>}>
  Rera
</Button></Typography>

<Box sx={{display:'flex',flexDirection:'row',mt:2,mb:2}}>
  <Box sx={{borderRight:1,borderColor:'#a0a0a0',minWidth:110,height:50}}>
<Typography sx={{fontSize:16,fontWeight:'700',pl:2,pr:2,color:'#010c1f'}}>{this.formatIndianCurrency(row.property_price)}</Typography>
<Typography sx={{fontSize:13,fontWeight:'500',pl:2,pr:2,color:'#666666'}}>{row.property_area} sqft</Typography>

  </Box>
  <Box sx={{borderRight:1,borderColor:'#a0a0a0',minWidth:130,height:50}}>

  <Typography sx={{fontSize:16,fontWeight:'700',pl:2,pr:2,color:'#010c1f'}}>{row.property_area} sqft</Typography>
  <Typography sx={{fontSize:13,fontWeight:'500',pl:2,pr:2,color:'#666666'}}>Plot area</Typography>

  </Box>
  <Box sx={{width:170,height:50}}>

  <Typography sx={{fontSize:16,fontWeight:'700',color:'#010c1f',ml:2,pr:2}}>{row.no_of_bed_room}</Typography>
  <Typography sx={{fontSize:13,fontWeight:'500',color:'#666666',ml:2,pr:2}}>{row.construction_status}</Typography>

  </Box>

</Box>

<Box>
<Typography sx={{
  fontSize:13,
  fontWeight:'500',
  textAlign:'justify',
   ml:2,
   textTransform:'capitalize',
  overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "3",
    WebkitBoxOrient: "vertical",
    pr:2
  }}>
    
  {row.property_street_name},{row.property_city_name},{row.property_district}, {row.property_state}  -  {row.property_area_pincode}
    </Typography>
</Box>

<Typography sx={{fontSize:14,fontWeight:'600',color:'#66b4da',display:'flex',mt:2,pl:2}}>TYPE : <Typography sx={{color:'#e60278',fontSize:14,fontWeight:'600',ml:1}}>{row.property_category}</Typography></Typography>
<Box sx={{width:'100%',display:'flex',justifyContent:'right',alignContent:'right',mt:2,mb:2}}>
<Button variant="outlined" disableElevation size="small" sx={{mr:2,fontSize:12}} 
   onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}
>Contact</Button>
<Button variant="contained" disableElevation size="small" sx={{mr:2,fontSize:12}} 
   onClick={()=>this.setState({
      is_enquiry_open:true,
      propertyDetails:row
     })}
>Enquiry now</Button>
</Box>


  </Box>
</Grid>

</Grid>



    </Card>
    </Box>
))
}
                  




<Box sx={{mt:4}}>
    <Stack spacing={2}>
      <Pagination size="small" color="primary" count={Math.ceil(this.state.size/20)} onChange={this.handlePageChange} variant="outlined" />
      </Stack>
</Box>





                  </Box>
                </Grid>


              </Grid>
            </Box>
          </Container>
        </Box>
        <Footer/>

          <Box>
                  <Modal
                    open={this.state.is_enquiry_open}
                    onClose={this.handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <Paper
                        sx={{
                          width: { xs: "90%", sm: "90%", md: "27%", lg: "27%" },
                          height: "65vh",
                          backgroundColor: "#fff",
                          borderRadius: 2,
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "right",
                          }}
                        >
                          <Paper
                            onClick={() =>
                              this.setState({
                                is_enquiry_open: false,
                                name : "",
        name : "",
        phone : "",
        email : ""
                              })
                            }
                            elevation={5}
                            sx={{
                              height: 30,
                              width: 30,
                              borderRadius: 1,
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              mr: -1,
                              mt: -1,
                            }}
                          >
                            <CloseIcon
                              sx={{ height: 20, width: 20, color: "#2486bb" }}
                            />
                          </Paper>
                        </Box>
        
                        <Typography
                          sx={{
                            fontSize: 17,
                            fontWeight: "600",
                            color:'#008ffb',
        
                            paddingLeft: { xs: 2, sm: 4 },
                            mb: 2,
                          }}
                        >
                        Enquire Now :
                        </Typography>
                        <Divider />
                        <Box
                          sx={{
                            overflowY: "scroll",
                            "&::-webkit-scrollbar": {
                              width: "5px",
                              borderRadius: 10,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              paddingLeft: { xs: 2, sm: 4 },
                              paddingRight: { xs: 2, sm: 4 },
                              height: "76vh",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 11,
                                fontWeight: "600",
                                padding: 0.2,
                                mt: 1,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              {" "}
                              YOUR NAME
                              <Typography sx={{ color: "red" }}>*</Typography>
                            </Typography>
                            <TextField
                              type="text"
                              InputProps={{
                                sx: { fontSize: 11, fontWeight: "600" },
                              }}
                              name="name"
                              value={this.state.name}
                              onChange={this.handleChange}
                              fullWidth
                              sx={{ backgroundColor: "#fff" }}
                              size="small"
                            />
        
                            <Typography
                              sx={{
                                fontSize: 11,
                                fontWeight: "600",
                                padding: 0.2,
                                mt: 1,
        
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              EMAIL ID
                              <Typography sx={{ color: "red" }}>*</Typography>
                            </Typography>
                            <TextField
                              type="text"
                              InputProps={{
                                sx: { fontSize: 11, fontWeight: "600" },
                              }}
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                              sx={{ backgroundColor: "#fff" }}
                              fullWidth
                              size="small"
                            />
        
                            <Typography
                              sx={{
                                fontSize: 11,
                                fontWeight: "600",
                                padding: 0.2,
                                mt: 1,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              PHONE <Typography sx={{ color: "red" }}>*</Typography>
                            </Typography>
                            <TextField
                              sx={{ backgroundColor: "#fff" }}
                              type="text"
                              InputProps={{
                                sx: { fontSize: 11, fontWeight: "600" },
                              }}
                              name="phone"
                              onChange={this.handleChange}
                              value={this.state.phone}
                              fullWidth
                              size="small"
                            />
                            
          
        
                            <Button
                              onClick={this.saveLeads}
                              variant="contained"
                              disableElevation
                              size="small"
                              sx={{
                                backgroundColor: "#2486bb",
                                mt: 2,
                                fontSize:11,
                                textTransform: "none",
                              }}
                            >
                            Enquire Now
                            </Button>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Modal>
                </Box>
      </div>
    );
  }
}

export default Properties;



const country= ['Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'The Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo, Democratic Republic of the',
  'Congo, Republic of the',
  'Costa Rica',
  'Côte d’Ivoire',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor (Timor-Leste)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'The Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, North',
  'Korea, South',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar (Burma)',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Sudan, South',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe'];